export const TRANSPARENT_DESKTOP_PATHS = [
  "/",
  "/busca",
  "/busca/hospedagem",
  "/busca/voos",
  "/busca/veiculos",
  "/busca/passagens-aereas",
  "/busca/passagens-onibus",
  "/busca/hospedagens",
  "/busca/alugar-carros",
  "/despesas/lancar-despesas",
  "/despesas/solicitar-adiantamento",
];

export const isSearchPath = (pathname: string) =>
  pathname === "/" || pathname === "/busca" || pathname.startsWith("/busca/");

export const MOBILE_ABSOLUTE_PATHS = [
  ...TRANSPARENT_DESKTOP_PATHS,
  "/despesas/lancar-despesas",
  "/despesas/solicitar-adiantamento",
  "/menu-opcoes",
  "/pedidos/meus-pedidos",
];

export const getNavBarPosition = (pathname: string, isMobileView: boolean) => {
  if (isMobileView) {
    return MOBILE_ABSOLUTE_PATHS.includes(pathname) ? "absolute" : "sticky";
  }
  return TRANSPARENT_DESKTOP_PATHS.includes(pathname) ? "absolute" : "sticky";
};
